
import request from '@/utils/request'

const prefix = '/django_rest/company/candidate-status'
const clientAdminPrefix = '/django_rest/client-admin/candidate-status'

export default {
  getCandidateStatusList (params) {
    return request.get('/django_rest/candidate-status/status/', { params })
  },
  getStatusChangeReasonList (params) {
    return request.get('/django_rest/candidate-status/change-reason/', { params })
  },
  getCandidateStatusChangeCauseList (params) {
    return request.get(`${prefix}/`, { params })
  },
  getCandidateStatusChangeCauseByCauseId (causeId, params) {
    return request.get(`${prefix}/${causeId}`, { params })
  },
  moveCandidateStatusChangeCause (data) {
    return request.put(`${prefix}/move/`, data)
  },
  saveCandidateStatusChangeCause (data) {
    return request.post(`${prefix}/`, data)
  },
  updateCandidateStatusChangeCause (causeId, data) {
    return request.put(`${prefix}/${causeId}`, data)
  },
  deleteCandidateStatusChangeCause (causeId, data) {
    return request.delete(`${prefix}/${causeId}`, data)
  },
  getAllCandidateStatusList (params) {
    return request.get(`${clientAdminPrefix}/`, { params })
  },
  getCandidateStatusInfoByStatusKey (params) {
    return request.get(`${clientAdminPrefix}/`, { params })
  },
  createCandidateStatus (params) {
    return request.post(`${clientAdminPrefix}/`, params)
  },
  updateCandidateStatus (params) {
    return request.put(`${clientAdminPrefix}/`, params)
  },
  updateCandidateStatusOrder (params) {
    return request.post(`${clientAdminPrefix}/sort/`, params)
  },
  getCompanyBingingCandidateStatusList (companyId) {
    return request.get(`/django_rest/candidate-status-binding/${companyId}/`)
  },
  updateCompanyBingingCandidateStatus (companyId, data) {
    return request.put(`/django_rest/candidate-status-binding/${companyId}/`, data)
  }
}
